import { render, staticRenderFns } from "./RiskCategoryView.vue?vue&type=template&id=e52eb080&"
import script from "./RiskCategoryView.vue?vue&type=script&lang=js&"
export * from "./RiskCategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports